module.exports = __webpack_public_path__ + "img/sn-fb.075a719c.svg";